import Vue from 'vue';
import App from './App.vue';

Vue.config.productionTip = false;

import Antd from 'ant-design-vue';

import 'ant-design-vue/dist/antd.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Antd).use(ElementUI);
import VueRouter from 'vue-router';

//引入路由器
import router from './router';
import axios from 'axios';
Vue.prototype.$axios = axios;
//使用插件
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
new Vue({
  render: (h) => h(App),
  router: router,
  beforeCreate() {
    Vue.prototype.$bus = this; //安装全局事件总线
  },
}).$mount('#app');
